import React from 'react'
import ModalFormUI from '../../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../../widgets/form/InputTextSF'

const RepaymentBalanceModalUI = ({ context, successMsg, errorList, setErrorList,
  // modes
  updateMode, submitted, status,
  // event handlers
  onSubmit, onCancelClick,
  // fields
  balance, onBalanceChange, balanceError, setBalanceError
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update balance'
    buttonLabel='Save'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='balance' label='Balance'
      value={balance} onChange={onBalanceChange}
      error={balanceError} setError={setBalanceError}
    />

  </ModalFormUI>

export default RepaymentBalanceModalUI
